export const NETWORK_TABS = [
  { label: "My Connections", path: "/network/my-network" },
  { label: "Clients", path: "/network/clients" },
  { label: "Favorites", path: "/network/favorited" },
  { label: "Requests", path: "/network/requests" },
  { label: "Discover New Connections", path: "/network/suggestions" },
];
